// extracted by mini-css-extract-plugin
module.exports = {"deviceSearchHeader":"DeviceSearchHeader_deviceSearchHeader___NBtR"};